import { useContext } from 'react';
import { IStepperContext } from './types';
import { StepperContext } from './Stepper';

const useStepper = (): IStepperContext => {
  const context = useContext(StepperContext);

  if (!context) {
    throw new Error('This component must be a <Stepper> component');
  }

  return context;
};

export default useStepper;
